import styled from "styled-components";
import { AlliePopover } from '../../../components/Popover';

export const StyledAllieTooltip = styled(AlliePopover)`
  &&{--width: fit-content}
  &&{--offset-x: 5px}
  &&{--offset-y: 40px}
`;
